import { render, staticRenderFns } from "./appbanneradvertiserManage.vue?vue&type=template&id=72d76d2b&scoped=true"
import script from "./appbanneradvertiserManage.vue?vue&type=script&lang=js"
export * from "./appbanneradvertiserManage.vue?vue&type=script&lang=js"
import style0 from "./appbanneradvertiserManage.vue?vue&type=style&index=0&id=72d76d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d76d2b",
  null
  
)

export default component.exports